import script from "./PeriodSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&setup=true&lang=js"

import "./PeriodSelector.vue?vue&type=style&index=0&id=ab8d7eac&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab8d7eac"]])

export default __exports__